var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2653B0",
    fillRule: "evenodd",
    d: "M15.001 0h-15v15h15zM3.368 4.658a1.301 1.301 0 1 0 0-2.602 1.301 1.301 0 0 0 0 2.602m2.493.962h2.156v.988s.586-1.17 2.178-1.17c1.42 0 2.597.7 2.597 2.832v4.498h-2.235V8.815c0-1.258-.672-1.397-1.183-1.397-1.063 0-1.245.917-1.245 1.561v3.789H5.861zm-1.359 0H2.233v7.148h2.27z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedin;